import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { DeletePaymentModal } from "../component/tableFunction/DeletePaymentModal";

// jotai
import { useSetAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getIncentives,
  getIncentive,
  putIncentive,
  postIncentive,
} from "../api/incentive";
import {
  getIncentiveServices,
  postIncentiveServices,
} from "../api/incentiveService";
import {
  getIncentiveHighRankCompanyDeposits,
  getIncentiveHighRankCompanyDeposit,
  putIncentiveHighRankCompanyDeposit,
  postIncentiveHighRankCompanyDeposit,
  deleteIncentiveHighRankCompanyDeposit,
} from "../api/incentiveHighRankCompanyDeposit";
import {
  getIncentiveSaleCompanyPayments,
  getIncentiveSaleCompanyPayment,
  putIncentiveSaleCompanyPayment,
  postIncentiveSaleCompanyPayment,
  deleteIncentiveSaleCompanyPayment,
} from "../api/incentiveSaleCompanyPayment";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import {
  getSerchHighRankCompanys,
  getSerchProducts,
  getSerchSaleCompanys,
} from "../api/serch";

// InterFace
import { incentiveTableColumn } from "../config/incentive";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

const postCSVColumnHighRankCompanyDeposit = [
  "上位店名",
  "商材名",
  "プラン名1",
  "、",
  "プラン名10",
  "条件適応期間 - 開始",
  "取次数",
  "上位店入金単価",
];
const postCSVColumnHighRankCompanyDepositResult = [
  "上位店名",
  "商材名",
  "プラン名1",
  "プラン名2",
  "プラン名3",
  "条件適応期間 - 開始",
  "取次数",
  "上位店入金単価",
];

const postCSVColumnSaleCompanyPayment = [
  "上位店名",
  "商材名",
  "プラン名1",
  "、",
  "プラン名10",
  "エントリーパートナー",
  "条件適応期間 - 開始",
  "条件適応期間 - 終了",
  "取次数",
  "パートナー支払単価",
];

const postCSVColumnSaleCompanyPaymentResult = [
  "上位店名",
  "商材名",
  "プラン名1",
  "プラン名2",
  "プラン名3",
  "エントリーパートナー",
  "条件適応期間 - 開始",
  "条件適応期間 - 終了",
  "取次数",
  "パートナー支払単価",
];

function Incentive() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "インセンティブ登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "上位店入金単価登録CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "パートナー支払単価登録CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "インセンティブ登録") {
      setOnDataAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "上位店入金単価登録CSV取込") {
      setPostHighRankCompanyDepositCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "パートナー支払単価登録CSV取込") {
      setPostSaleCompanyPaymentCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "入金単価一覧") {
      getSubtableDataHighRankCompanyDeposit();
    }
    if (getSubTableName.name === "パートナー一覧") {
      getSubtableDataSaleCompanyPayment();
    }
    if (getSubTableName.name === "サービス一覧") {
      getSubtableDataService();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "入金単価一覧"
    ) {
      // 上位店入金単価の削除
      setDeleteHighRankCompanyDepositInf({
        status: "open",
        name: "上位店入金単価の削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "パートナー一覧"
    ) {
      // パートナー支払単価の削除
      setDeleteEntrySaleCompanyPaymentInf({
        status: "open",
        name: "パートナー支払単価の削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [
    tableOriginalFunc.name,
    tableOriginalFunc.key,
    tableOriginalFunc.subTableColumnName,
  ]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "上位店入金単価詳細") {
      getSubtableDataDetailHighRankCompanyDeposit();
    }
    if (getSubTableDetail.name === "パートナー支払単価詳細") {
      getSubtableDataDetailSaleCompanyPayment();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "入金単価追加") {
      openModalSubtableDataAddHighRankCompanyDeposit();
    }
    if (getSubTableAdd.name === "パートナー追加") {
      openModalSubtableDataAddSaleCompanyPayment();
    }
    if (getSubTableAdd.name === "サービス追加") {
      openModalSubtableDataAddService();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string;
  } | null>(null);

  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);

  // データ登録
  const addDataColumns = incentiveTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onDataAddModal, setOnDataAddModal] = useState(false);
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  const serchColumn = incentiveTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [serchString, setSerchString] = useState<{ [key: string]: string }>(serchColumn);
  const [serchStringView, setSerchStringView] = useState<{ [key: string]: string }>(serchColumn);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getIncentives({
      ...serchString,
      deposit_start_date_start: serchString.deposit_start_date_start ?? "",
      deposit_start_date_end: serchString.deposit_start_date_end ?? "",
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.incentives);
      const countIncentives = Number(fetchData.countIncentives);
      setTotalCount(countIncentives);
      setMaxPageNumber(Math.ceil(countIncentives / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 顧客詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getIncentive(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 顧客編集
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putIncentive(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // データ新規登録
  async function postAddData() {
    setIsLoading(true);
    setOnDataAddModal(false);
    const postResponce = await postIncentive(addData);
    if (postResponce === "success") {
      await getTableData(true);
      setAddData(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // サービス一覧取得
  async function getSubtableDataService() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getIncentiveServices(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // サービス登録
  const [addDataService, setAddDataService] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    incentive_id: "",
    all_service: [],
    select_service: [],
  });
  const [onDataAddModalService, setOnDataAddModalService] = useState(false);
  async function openModalSubtableDataAddService() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getIncentiveServices(
        getSubTableAdd.row.id as string
      );
      setAddDataService({
        incentive_id: getSubTableAdd.row.id as string,
        all_service: fetchData.serviceDatas,
        select_service: fetchData.sudDatas,
      });
      setOnDataAddModalService(true);
      setIsLoading(false);
    }
  }
  async function postAddDataService() {
    setIsLoading(true);
    setOnDataAddModalService(false);
    const postResponce = await postIncentiveServices(addDataService);
    if (postResponce === "success") {
      if (getSubTableName.name == "サービス一覧") {
        await getSubtableDataService();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataService({
        incentive_id: "",
        all_service: [],
        select_service: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalService(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 上位店入金単価一覧取得
  async function getSubtableDataHighRankCompanyDeposit() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getIncentiveHighRankCompanyDeposits(
        getSubTableName.key.id,
        {
          deposit_start_date_start: serchString.deposit_start_date_start,
          deposit_start_date_end: serchString.deposit_start_date_end,
        }
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価詳細取得
  async function getSubtableDataDetailHighRankCompanyDeposit() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getIncentiveHighRankCompanyDeposit(
        getSubTableDetail.key.id
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価編集
  const [
    editDataDetailHighRankCompanyDeposit,
    setEditDataDetailHighRankCompanyDeposit,
  ] = useState<EditDataDifine | null>(null);
  async function putEditDataDetailHighRankCompanyDeposit() {
    if (editDataDetailHighRankCompanyDeposit !== null) {
      setIsLoading(true);
      setEditDataDetailHighRankCompanyDeposit({
        ...editDataDetailHighRankCompanyDeposit,
        status: "editing",
      });
      const putResponce = await putIncentiveHighRankCompanyDeposit(
        editDataDetailHighRankCompanyDeposit
      );
      if (putResponce == "success") {
        await getSubtableDataHighRankCompanyDeposit();
        await getSubtableDataDetailHighRankCompanyDeposit();
      }
      setEditDataDetailHighRankCompanyDeposit({
        ...editDataDetailHighRankCompanyDeposit,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価新規登録
  const addDataColumnsHighRankCompanyDeposit =
    incentiveTableColumn.subTable[1].subDataColumn.reduce((column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [addDataHighRankCompanyDeposit, setAddDataHighRankCompanyDeposit] =
    useState<{
      [key: string]: string | boolean | any[];
    }>(addDataColumnsHighRankCompanyDeposit);
  const [
    onDataAddModalHighRankCompanyDeposit,
    setOnDataAddModalHighRankCompanyDeposit,
  ] = useState(false);
  async function openModalSubtableDataAddHighRankCompanyDeposit() {
    let _addDataHighRankCompanyDeposit = addDataHighRankCompanyDeposit;
    incentiveTableColumn.subTable[1].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataHighRankCompanyDeposit[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataHighRankCompanyDeposit[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataHighRankCompanyDeposit[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataHighRankCompanyDeposit(_addDataHighRankCompanyDeposit);
    if (getSubTableAdd.row) {
      setOnDataAddModalHighRankCompanyDeposit(true);
    }
  }
  async function postAddDataHighRankCompanyDeposit() {
    setIsLoading(true);
    setOnDataAddModalHighRankCompanyDeposit(false);
    const postResponce = await postIncentiveHighRankCompanyDeposit(
      addDataHighRankCompanyDeposit
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "入金単価一覧") {
        await getSubtableDataHighRankCompanyDeposit();
      }
      await getTableData(true);
      setAddDataHighRankCompanyDeposit(addDataColumnsHighRankCompanyDeposit);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalHighRankCompanyDeposit(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 上位店入金単価登録CSV取込
  const [
    postHighRankCompanyDepositCSVStatus,
    setPostHighRankCompanyDepositCSVStatus,
  ] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postHighRankCompanyDepositCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postHighRankCompanyDepositCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postHighRankCompanyDepositCSVStatus]);
  async function postHighRankCompanyDepositsCSV(postDatas: File) {
    setPostHighRankCompanyDepositCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostHighRankCompanyDepositCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "incentiveHighRankCompanyDeposit";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostHighRankCompanyDepositCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postHighRankCompanyDepositCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        if (getSubTableName.name == "入金単価一覧") {
          await getSubtableDataHighRankCompanyDeposit();
        }
        setPostHighRankCompanyDepositCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postHighRankCompanyDepositCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostHighRankCompanyDepositCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postHighRankCompanyDepositCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostHighRankCompanyDepositCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 上位店入金単価一覧取得
  async function getSubtableDataSaleCompanyPayment() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getIncentiveSaleCompanyPayments(
        getSubTableName.key.id,
        {
          entry_sale_company_name: serchString.entry_sale_company_name,
          deposit_start_date_start: serchString.deposit_start_date_start,
          deposit_start_date_end: serchString.deposit_start_date_end,
        }
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 検索条件（条件適応期間・エントリーパートナー）変更時にサブテーブルを再取得
  useEffect(() => {
    if (getSubTableName.name === "入金単価一覧") {
      getSubtableDataHighRankCompanyDeposit();
    }
    if (getSubTableName.name === "パートナー一覧") {
      getSubtableDataSaleCompanyPayment();
    }
  }, [
    serchString.deposit_start_date_start,
    serchString.deposit_start_date_end,
    serchString.entry_sale_company_name,
  ]);

  // 上位店入金単価詳細取得
  async function getSubtableDataDetailSaleCompanyPayment() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getIncentiveSaleCompanyPayment(
        getSubTableDetail.key.id
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価編集
  const [
    editDataDetailSaleCompanyPayment,
    setEditDataDetailSaleCompanyPayment,
  ] = useState<EditDataDifine | null>(null);
  async function putEditDataDetailSaleCompanyPayment() {
    if (editDataDetailSaleCompanyPayment !== null) {
      setIsLoading(true);
      setEditDataDetailSaleCompanyPayment({
        ...editDataDetailSaleCompanyPayment,
        status: "editing",
      });
      const putResponce = await putIncentiveSaleCompanyPayment(
        editDataDetailSaleCompanyPayment
      );
      if (putResponce == "success") {
        await getSubtableDataSaleCompanyPayment();
        await getSubtableDataDetailSaleCompanyPayment();
      }
      setEditDataDetailSaleCompanyPayment({
        ...editDataDetailSaleCompanyPayment,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価新規登録
  const addDataColumnsSaleCompanyPayment =
    incentiveTableColumn.subTable[2].subDataColumn.reduce((column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
            payment_end_date_post: true,
          };
        }
      } else {
        return {
          ...column,
          payment_end_date_post: true,
        };
      }
    }, {});
  const [addDataSaleCompanyPayment, setAddDataSaleCompanyPayment] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsSaleCompanyPayment);
  const [
    onDataAddModalSaleCompanyPayment,
    setOnDataAddModalSaleCompanyPayment,
  ] = useState(false);
  async function openModalSubtableDataAddSaleCompanyPayment() {
    let _addDataSaleCompanyPayment = addDataSaleCompanyPayment;
    incentiveTableColumn.subTable[2].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataSaleCompanyPayment[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataSaleCompanyPayment[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataSaleCompanyPayment[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataSaleCompanyPayment(_addDataSaleCompanyPayment);
    if (getSubTableAdd.row) {
      setOnDataAddModalSaleCompanyPayment(true);
    }
  }
  async function postAddDataSaleCompanyPayment() {
    setIsLoading(true);
    setOnDataAddModalSaleCompanyPayment(false);
    const postResponce = await postIncentiveSaleCompanyPayment(
      addDataSaleCompanyPayment
    );
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.name == "パートナー一覧") {
        await getSubtableDataSaleCompanyPayment();
      }
      setAddDataSaleCompanyPayment(addDataColumnsSaleCompanyPayment);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalSaleCompanyPayment(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 上位店入金単価登録CSV取込
  const [postSaleCompanyPaymentCSVStatus, setPostSaleCompanyPaymentCSVStatus] =
    useState<{
      status: "none" | "open" | "posting" | "result" | "loading" | "error";
      message: string;
      result: { [key: string]: any }[];
      header_location: string;
    }>({
      status: "none",
      message: "",
      result: [],
      header_location: "None",
    });
  useEffect(() => {
    if (postSaleCompanyPaymentCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postSaleCompanyPaymentCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postSaleCompanyPaymentCSVStatus]);
  async function postSaleCompanyPaymentsCSV(postDatas: File) {
    setPostSaleCompanyPaymentCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostSaleCompanyPaymentCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "incentiveSaleCompanyPayment";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostSaleCompanyPaymentCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postSaleCompanyPaymentCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        if (getSubTableName.name == "入金単価一覧") {
          await getSubtableDataSaleCompanyPayment();
        }
        setPostSaleCompanyPaymentCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postSaleCompanyPaymentCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostSaleCompanyPaymentCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postSaleCompanyPaymentCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostSaleCompanyPaymentCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 上位店入金単価の削除
  const [deleteHighRankCompanyDepositInf, setDeleteHighRankCompanyDepositInf] =
    useState<{
      status: null | "loading" | "open" | "success" | "failed";
      key: { [key: string]: string };
      name: string;
      message: string;
    }>({
      status: null,
      name: "",
      key: {},
      message: "",
    });
  async function deleteHighRankCompanyDepositFunc() {
    setDeleteHighRankCompanyDepositInf({
      ...deleteHighRankCompanyDepositInf,
      status: "loading",
    });
    const id = deleteHighRankCompanyDepositInf.key.id;
    const responce = await deleteIncentiveHighRankCompanyDeposit(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataHighRankCompanyDeposit();
      setDeleteHighRankCompanyDepositInf({
        ...deleteHighRankCompanyDepositInf,
        status: "success",
      });
    } else {
      setDeleteHighRankCompanyDepositInf({
        ...deleteHighRankCompanyDepositInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteHighRankCompanyDepositInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteHighRankCompanyDepositInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteHighRankCompanyDepositInf]);

  // パートナー支払単価の削除
  const [
    deleteEntrySaleCompanyPaymentInf,
    setDeleteEntrySaleCompanyPaymentInf,
  ] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    name: string;
    message: string;
  }>({
    status: null,
    name: "",
    key: {},
    message: "",
  });
  async function deleteEntrySaleCompanyPaymentFunc() {
    setDeleteEntrySaleCompanyPaymentInf({
      ...deleteEntrySaleCompanyPaymentInf,
      status: "loading",
    });
    const id = deleteEntrySaleCompanyPaymentInf.key.id;
    const responce = await deleteIncentiveSaleCompanyPayment(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataSaleCompanyPayment();
      setDeleteEntrySaleCompanyPaymentInf({
        ...deleteEntrySaleCompanyPaymentInf,
        status: "success",
      });
    } else {
      setDeleteEntrySaleCompanyPaymentInf({
        ...deleteEntrySaleCompanyPaymentInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteEntrySaleCompanyPaymentInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteEntrySaleCompanyPaymentInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteEntrySaleCompanyPaymentInf]);
  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[]
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        }
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[]
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        }
      );
      setProductNameList(productNameList);
    }
  }

  // サービス新規登録時、選択した上位店により商材一覧
  const [selectProductList, setSelectProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  useEffect(() => {
    let selectProductList: {
      id: number;
      high_rank_company_id: number;
      product_name: string;
    }[] = [];
    const high_rank_company_id = Number(addData.high_rank_company_id);
    productList.map((product) => {
      if (product.high_rank_company_id === high_rank_company_id) {
        selectProductList.push(product);
      }
    });
    setSelectProductList(selectProductList);
  }, [addData]);
  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        }
      );
      setCampanyNameList(companyNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getProductList();
    getSaleCompanysList();
  }, []);

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box data-testid="incentive-page" style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={incentiveTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={{
                name: "",
                key: {},
                subData: [],
              }}
              setGetSubSubTableName={() => {}}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={() => {}}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={incentiveTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={incentiveTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="Incentive"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={incentiveTableColumn.detailTitle}
        editAuth={incentiveTableColumn.editAuth}
        dataColumn={incentiveTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            incentiveTableColumn.subTable[1].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailHighRankCompanyDeposit !== null &&
            editDataDetailHighRankCompanyDeposit.status !== "editing") ||
            editDataDetailHighRankCompanyDeposit === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={incentiveTableColumn.subTable[1].subTableDetailTitle}
        editAuth={incentiveTableColumn.subTable[1].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={incentiveTableColumn.subTable[1].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailHighRankCompanyDeposit}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            incentiveTableColumn.subTable[2].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailSaleCompanyPayment !== null &&
            editDataDetailSaleCompanyPayment.status !== "editing") ||
            editDataDetailSaleCompanyPayment === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={incentiveTableColumn.subTable[2].subTableDetailTitle}
        editAuth={incentiveTableColumn.subTable[2].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={incentiveTableColumn.subTable[2].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailSaleCompanyPayment}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailHighRankCompanyDeposit !== null &&
          editDataDetailHighRankCompanyDeposit.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailHighRankCompanyDeposit(null)}
        editData={editDataDetailHighRankCompanyDeposit}
        setEditData={setEditDataDetailHighRankCompanyDeposit}
        putEditData={putEditDataDetailHighRankCompanyDeposit}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailSaleCompanyPayment !== null &&
          editDataDetailSaleCompanyPayment.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailSaleCompanyPayment(null)}
        editData={editDataDetailSaleCompanyPayment}
        setEditData={setEditDataDetailSaleCompanyPayment}
        putEditData={putEditDataDetailSaleCompanyPayment}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModal}
        swCloseModal={() => {
          setOnDataAddModal(false);
          setAddDataName("");
        }}
        addTitle={incentiveTableColumn.addTitle}
        dataColumn={incentiveTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={[]}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalService}
        swCloseModal={() => {
          setOnDataAddModalService(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={incentiveTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={incentiveTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataService}
        addData={addDataService}
        setAddData={setAddDataService}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalHighRankCompanyDeposit}
        swCloseModal={() => {
          setOnDataAddModalHighRankCompanyDeposit(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={incentiveTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={incentiveTableColumn.subTable[1].subDataColumn}
        postAddData={postAddDataHighRankCompanyDeposit}
        addData={addDataHighRankCompanyDeposit}
        setAddData={setAddDataHighRankCompanyDeposit}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalSaleCompanyPayment}
        swCloseModal={() => {
          setOnDataAddModalSaleCompanyPayment(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={incentiveTableColumn.subTable[2].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={incentiveTableColumn.subTable[2].subDataColumn}
        postAddData={postAddDataSaleCompanyPayment}
        addData={addDataSaleCompanyPayment}
        setAddData={setAddDataSaleCompanyPayment}
        companyList={companyList}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <PostCSVModal
        onModal={
          postHighRankCompanyDepositCSVStatus.status !== "none" &&
          postHighRankCompanyDepositCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostHighRankCompanyDepositCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postHighRankCompanyDepositCSVStatus}
        setPostCSVStatus={setPostHighRankCompanyDepositCSVStatus}
        postCSVFunc={postHighRankCompanyDepositsCSV}
        postCSVTitle={"上位店入金単価登録CSV取込"}
        postCSVColumn={postCSVColumnHighRankCompanyDeposit}
        postCSVColumnResult={postCSVColumnHighRankCompanyDepositResult}
        postCSVPath="incentiveHighRankCompanyDeposit"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postSaleCompanyPaymentCSVStatus.status !== "none" &&
          postSaleCompanyPaymentCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostSaleCompanyPaymentCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postSaleCompanyPaymentCSVStatus}
        setPostCSVStatus={setPostSaleCompanyPaymentCSVStatus}
        postCSVFunc={postSaleCompanyPaymentsCSV}
        postCSVTitle={"パートナー支払単価登録CSV取込"}
        postCSVColumn={postCSVColumnSaleCompanyPayment}
        postCSVColumnResult={postCSVColumnSaleCompanyPaymentResult}
        postCSVPath="incentiveSaleCompanyPayment"
        productList={[]}
        categoryList={[]}
      />
      <DeletePaymentModal
        onModal={
          deleteHighRankCompanyDepositInf.status !== null &&
          deleteHighRankCompanyDepositInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteHighRankCompanyDepositInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteHighRankCompanyDepositInf}
        setDeletePaymentInf={setDeleteHighRankCompanyDepositInf}
        deletePayment={deleteHighRankCompanyDepositFunc}
      />
      <DeletePaymentModal
        onModal={
          deleteEntrySaleCompanyPaymentInf.status !== null &&
          deleteEntrySaleCompanyPaymentInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteEntrySaleCompanyPaymentInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteEntrySaleCompanyPaymentInf}
        setDeletePaymentInf={setDeleteEntrySaleCompanyPaymentInf}
        deletePayment={deleteEntrySaleCompanyPaymentFunc}
      />
    </Box>
  );
}

export default Incentive;
